const INITIAL_STATE = {
  cambios: [],
  cambio: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'CAMBIOS_FETCH':
      return { ...state, cambios: action.payload }
    case 'CAMBIO_FETCH':
      return { ...state, cambio: action.payload }

    default:
      return state
  }
}